import React, {Component} from 'react';
import Constants from '../../inc/Constants';
import {jsUcfirst} from "../../inc/Helpers";
import { NavItem, NavLink } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


class PlaceListItem extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<NavItem active={this.props.active} className="placesCheckboxHolder p-1">
                <input type="checkbox" className="placesCheckbox d-none" name={this.props.name} id={this.props.name} value={this.props.name} onChange={() => this.props.selectItem(this.props.name)} checked={this.props.active} />
				<NavLink className="text-center" active={this.props.active}>
					<label htmlFor={this.props.name}>
                        <FontAwesomeIcon
                            icon={Constants.PLACEICONS[this.props.name]}
                            size= '2x'
                        />
                        <br/>
                        {jsUcfirst(this.props.niceName)}
					</label>
                </NavLink>
			</NavItem>
		)
	}
}

export default PlaceListItem;
